import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import RetakeExamButton from './RetakeExamButton';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { getExamIsRecent, isExpired } from '../examsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamFailedScreen = ({
  track,
  mostRecentExamAttempt,
  award,
  pendingPracticalExercises
}) => {
  var _track$exam;
  const examIsRecent = getExamIsRecent(mostRecentExamAttempt);
  const certificationExpired = !examIsRecent && isExpired(award === null || award === void 0 ? void 0 : award.expiresAt);
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [!certificationExpired && /*#__PURE__*/_jsx(TrackViewAwardLink, {
        award: award,
        certification: track && (track.certification || !!track.exam),
        trackId: track.id,
        useCurrentText: mostRecentExamAttempt ? !mostRecentExamAttempt.passed : false
      }), /*#__PURE__*/_jsx(RetakeExamButton, {
        mostRecentExamAttempt: mostRecentExamAttempt,
        use: "primary"
      })]
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.failHeading"
    }),
    illustration: /*#__PURE__*/_jsx(Pictogram, {
      name: "MissedGoal"
    }),
    mostRecentExamAttempt: mostRecentExamAttempt,
    pendingPracticalExercises: pendingPracticalExercises,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourScoreVsRequiredScore",
      options: {
        passThreshold: mostRecentExamAttempt && mostRecentExamAttempt.passThreshold,
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && ((_track$exam = track.exam) === null || _track$exam === void 0 ? void 0 : _track$exam.length) || 0
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.failSubheading"
    }),
    track: track
  });
};
export default ExamFailedScreen;